import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const $body = $('body');
const $hamburger = $('.header__hamburger');
const $navButton = $('.navigation__button');
const $navMenu = $('.navigation-menu');
const $close = $('.navigation-menu__close');
const $navMenuTitle = $('.navigation-menu__title.desktop');
const $navMenuTitleArrow = $('.navigation-menu__title-arrow');
const $navSubmenuWrapper = $('.navigation-submenu__wrapper');
const $navSubmenuLink = $('.navigation-submenu__link');
const $navMiscLink = $('.navigation-menu-misc__link');
const $searchTrigger = $('.search__trigger');

$(function () {
    $window.on('resize:width', debounce(hideNav, true));
    $hamburger.on('click', function (event) {
        event.stopPropagation();
        toggleNav();
    });
    $close.on('click', hideNav);
    $navMenu.on('click', function (event) {
        event.stopPropagation();
    });
    $navMenuTitleArrow.on('click', function (event) {
        const trigger = $(this).parent();
        if (trigger.attr('href') !== undefined) {
            event.preventDefault();
            event.stopPropagation();
            toggleMenu(trigger);
        }
    });
    $navMenuTitle.on({
        mouseover: function () {
            const trigger = $(this);
            if (trigger.attr('href') !== undefined) {
                const menu = trigger.parent().find('.navigation-submenu');
                if (menu.length !== 0) {
                    showMenu(trigger, menu);
                }
            }
        },
        focus: function () {
            const trigger = $(this);
            if (trigger.attr('href') !== undefined) {
                const menu = trigger.parent().find('.navigation-submenu');
                hideMenu();
                if (menu.length !== 0) {
                    showMenu(trigger, menu);
                }
            }
        },
        mouseleave: function () {
            const trigger = $(this);
            if (trigger.attr('href') !== undefined) {
                const menu = trigger.parent().find('.navigation-submenu');
                if (menu.length !== 0) {
                    if (menu.filter(':hover').length === 0) {
                        hideMenu();
                    }
                }
            }
        },
    });

    $navSubmenuWrapper.on({
        mouseleave: function () {
            const menu = $(this);
            const trigger = menu
                .closest('.navigation-menu__elem')
                .find('.navigation-menu__title.desktop');
            if (trigger.attr('href') !== undefined && trigger.is(':visible')) {
                hideMenu();
            }
        },
    });

    $navSubmenuLink.on({
        focus: function () {
            const thisEl = $(this);
            const trigger = thisEl.parents('li.navigation-menu__elem').find('a.navigation-menu__title.desktop');
            const menu = thisEl.parents('div.navigation-submenu:first');
            if (menu.length !== 0) {
                showMenu(trigger, menu);
            }
        },
    });

    $body.on('click', hideNav);
    $searchTrigger.on('click', hideNav);
    $navButton.on('click', hideNav);
    $navMiscLink.on('click', hideNav);
    $navSubmenuLink.on('click', hideNav);
});

function toggleNav() {
    if ($navMenu.hasClass('active')) {
        hideNav();
    } else {
        showNav();
    }
}

function showNav() {
    $navMenu.addClass('active');
    navOverflow();
    $navMenu.on('scroll', navOverflow);
    $window.on('resize:height', debounce(navOverflow));
}

function hideNav() {
    $navMenu.scrollTop(0);
    $navMenu.removeClass('active');
    $navMenu.off('scroll', navOverflow);
    $window.off('resize:height', debounce(navOverflow));
    hideMenu();
}

const navScrolledTop = () => $navMenu.scrollTop() === 0;
const navScrolledBottom = () =>
    Math.ceil($navMenu.scrollTop() + $navMenu.outerHeight()) >= Math.ceil($navMenu[0].scrollHeight);

function navOverflow() {
    if (navScrolledTop() && navScrolledBottom()) {
        $navMenu.addClass('menu-is-up menu-is-down');
    } else {
        if (navScrolledTop()) {
            $navMenu.addClass('menu-is-up');
        } else {
            $navMenu.removeClass('menu-is-up');
        }

        if (navScrolledBottom()) {
            $navMenu.addClass('menu-is-down');
        } else {
            $navMenu.removeClass('menu-is-down');
        }
    }
}

function toggleMenu(trigger) {
    const menu = trigger.parent().find('.navigation-submenu');
    if (menu.length !== 0) {
        if (menu.hasClass('active')) {
            hideMenu();
        } else {
            showMenu(trigger, menu);
        }
    }
}

function showMenu(trigger, menu) {
    hideMenu();
    if (menu.is(':hidden')) {
        menu.slideDown(300, function () {
            menu.addClass('active');
            navOverflow();
        });
    } else {
        menu.addClass('active');
    }
    trigger.addClass('active');
}

function hideMenu() {
    const $activeMenus = $('.navigation-submenu.active');
    $activeMenus.each(function () {
        const $thisEl = $(this);
        const attr = $thisEl.attr('style');
        if (typeof attr !== 'undefined' && attr !== false) {
            $thisEl.slideUp(300, function () {
                $thisEl.removeAttr('style');
                navOverflow();
            });
        }
        $thisEl.removeClass('active');
    });
    const $activeLinks = $('.navigation-menu__title.active');
    $activeLinks.each(function () {
        const $thisEl = $(this);
        $thisEl.removeClass('active');
    });
}
